export default __webpack_public_path__ + "static/media/express.a729d33d.svg";